import { render, staticRenderFns } from "./imageConfig.vue?vue&type=template&id=6446e957"
import script from "./imageConfig.vue?vue&type=script&lang=js"
export * from "./imageConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports